import {
  CARD,
  IMAGE_MAP,
  LayoutColumnsDefinition,
  LayoutListDefinition,
  LAYOUT_COLUMNS,
  LAYOUT_LIST,
  POPUP,
  PopupDefinition,
  TEXT,
  AUDIO_POPUP,
  AudioPopupDefinition
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';
import { useEditorStore } from '~/shell/Store';
import { isMobile } from 'react-device-detect';

export const Interactive4: Translator = sequence => {
  const { contentEditable } = useEditorStore.getState();

  const columns = {
    type: LAYOUT_COLUMNS,
    id: `${sequence.id}-columns`,
    items: [],
    values: {}
  } as LayoutColumnsDefinition;

  let maxWidth = 1200;
  let maxHeight = 800;

  let originMaxWidth = 1200;
  let originMaxHeight = 800;

  const getCoordinatesInPercentage = (
    left: number,
    top: number,
    maxWidth: number,
    maxHeight: number
  ) => {
    return {
      left: (left * 100) / maxWidth,
      top: (top * 100) / maxHeight
    };
  };

  const root = translate(sequence, item => {
    switch (item.__typename) {
      case 'ImageMap':
        if (
          item.pictures &&
          item.pictures.length &&
          item.pictures?.[0]?.mediaUrl
        ) {
          maxWidth = item.pictures?.[0]?.width as number;
          maxHeight = item.pictures?.[0]?.height as number;

          originMaxWidth = maxWidth;
          originMaxHeight = maxHeight;
        }

        if (!contentEditable) {
          maxWidth = 400;
          maxHeight = 420;
        }

        columns.items.push({
          id: 'LAYOUT_LIST',
          type: LAYOUT_LIST,
          values: { align: 'center' },
          items: [
            {
              type: CARD,
              id: '1',
              values: {
                clearStyles: 'lg',
                height: '425px',
                width: '400px',
                padding: '0px'
              },
              items: [
                {
                  type: IMAGE_MAP,
                  id: item.id,
                  values: {
                    imageUrl: item.pictures?.[0]?.mediaUrl,
                    w: '400px',
                    h: '420px'
                  },
                  items: (item.items || []).map((i, index) => {
                    const parts = (i.coordinates || '').split(',');

                    const coordinatesInPercentage = getCoordinatesInPercentage(
                      parseInt(parts[0]),
                      parseInt(parts[1]),
                      originMaxWidth,
                      originMaxHeight
                    );
                    const coordinatesInPercentageFromBox =
                      getCoordinatesInPercentage(
                        parseInt(parts[0]),
                        parseInt(parts[1]),
                        400,
                        420
                      );

                    if (i.audios) {
                      let _left = !contentEditable
                        ? coordinatesInPercentage.left - 5 > 0
                          ? coordinatesInPercentage.left - 5
                          : 1
                        : coordinatesInPercentage.left;

                      let _top = !contentEditable
                        ? coordinatesInPercentage.top - 5 > 0
                          ? coordinatesInPercentage.top - 5
                          : 1
                        : coordinatesInPercentage.top;

                      if (isMobile) {
                        if (!contentEditable && _left > 80) {
                          _left = 80;
                        }

                        if (!contentEditable && _top > 80) {
                          _top = 80;
                        }
                      }

                      return {
                        type: AUDIO_POPUP,
                        id: `${(i as any).id ?? item.id}-${index}`,
                        items: [],
                        values: {
                          title: item.variant == 'number' ? index + 1 : null,
                          left: _left,
                          top: _top,
                          name: i.title,
                          body: i.body,
                          mediaUrl: i.audios?.[0]?.mediaUrl,
                          subtitlesUrl: i.audios?.[0]?.subtitlesUrl,
                          blocking: true,
                          replay: true,
                          isPopupCentered: isMobile ? true : false
                        }
                      } as AudioPopupDefinition;
                    } else {
                      let _left = coordinatesInPercentageFromBox.left;
                      let _top = coordinatesInPercentageFromBox.top;

                      if (!contentEditable && _left > 330) {
                        _left = 320;
                      }

                      if (!contentEditable && _top > 340) {
                        _top = 340;
                      }

                      if (isMobile) {
                        if (!contentEditable && _left > 80) {
                          _left = 80;
                        }

                        if (!contentEditable && _top > 80) {
                          _top = 80;
                        }
                      }

                      if (!_left && !_top) {
                        _left = 10;
                        _top = 10;
                      }

                      return {
                        type: POPUP,
                        id: `${(i as any).id ?? item.id}-${index}`,
                        values: {
                          btnTitle: item.variant == 'number' ? index + 1 : '+',
                          left: _left,
                          top: _top,
                          title: i.title,
                          subtitle: i.subtitle,
                          body: i.body,
                          blocking: true,
                          btnSize: 85,
                          isPopupCentered: isMobile ? true : false,
                          metric: contentEditable ? 'px' : '%'
                        }
                      } as PopupDefinition;
                    }
                  })
                }
              ]
            }
          ]
        });
        break;
      case 'Text':
      case 'Question':
        columns.items.push({
          id: 'LAYOUT_LIST_RIGHT',
          type: LAYOUT_LIST,
          values: { align: 'left', padded: true },
          items: [
            {
              type: TEXT,
              id: `${item.id}_subtitle`,
              items: [],
              values: {
                value: item.subtitle,
                variant: 'sub_heading',
                icon: item.icon
              }
            },
            {
              type: TEXT,
              id: `${item.id}_title`,
              items: [],
              values: {
                value: item.title,
                variant: 'heading2'
              }
            },
            {
              type: TEXT,
              id: `${item.id}_body`,
              items: [],
              values: {
                value: item.body
              }
            }
          ]
        } as LayoutListDefinition);
        break;
    }
    return null;
  });

  root.items.push(columns);
  return root;
};
